import React from 'react';
import { HOME_RESULTS, RESULTS_TICKER } from '../../content/placeholders';
import { Sparkle } from '../brand/Jaipur';
import './home.css';

/** Client logos (founder-owned brands Aarkin / Go4Lead intentionally left out). */
const CLIENT_LOGOS = [
  { src: '/images/clients_logos/1.webp', alt: 'Partywalas' },
  { src: '/images/clients_logos/2.webp', alt: 'Phylaxis.ai' },
  { src: '/images/clients_logos/3.webp', alt: 'Junction 14' },
  { src: '/images/clients_logos/4.webp', alt: 'Senyora' },
  { src: '/images/clients_logos/5.webp', alt: 'Enrich Global Infra' },
  { src: '/images/clients_logos/6.webp', alt: 'Amrita Naturals' },
  { src: '/images/clients_logos/7.webp', alt: 'ABnCO Group' },
  { src: '/images/clients_logos/8.webp', alt: 'Star Brothers' },
  { src: '/images/clients_logos/11.webp', alt: 'Kavvya' },
  { src: '/images/clients_logos/12.webp', alt: 'Utkrasht Udhyog Seva' },
  { src: '/images/clients_logos/13.webp', alt: 'Study Abroad' },
  { src: '/images/himee ride.webp', alt: 'Himee Ride' },
  { src: '/images/safal.webp', alt: 'Safal' },
  { src: '/images/kap.webp', alt: 'KAP' },
  { src: '/images/clients_logos/Logo.webp', alt: 'MedEqual' },
  { src: '/images/clients_logos/logoB.webp', alt: 'Wood Designer' },
];

const formatResult = (r) => `${Number(r.value).toFixed(r.decimals || 0)}${r.suffix || ''}`;

export default function ResultsStrip() {
  return (
    <section aria-labelledby="home-results-title" className="relative overflow-x-clip bg-apn-bg pb-12 pt-4 sm:pb-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 id="home-results-title" className="sr-only">
          Results for our clients
        </h2>
        <ul className="grid gap-3 sm:grid-cols-3 sm:gap-4">
          {HOME_RESULTS.map((r, i) => (
            <li
              key={r.label}
              data-animate="fade-up"
              data-animate-delay={i * 0.08}
              className="relative overflow-hidden rounded-3xl border border-apn-line bg-apn-surface p-6 sm:p-7"
            >
              <p
                data-animate="counter"
                data-animate-delay={0.1 + i * 0.08}
                className={`font-display text-[clamp(3.25rem,11vw,5.5rem)] font-extrabold leading-none tracking-[-0.04em] sm:text-[clamp(3rem,6vw,5.5rem)] ${
                  i === 0 ? 'text-apn-orange' : i === 1 ? 'text-apn-pink' : 'text-apn-indigo'
                }`}
              >
                {formatResult(r)}
              </p>
              <p className="mt-3 text-base font-semibold leading-snug text-apn-ink sm:text-lg">{r.label}</p>
              <p className="mt-1 text-sm text-apn-muted">{r.period}</p>
              <Sparkle className="absolute right-5 top-5 h-5 w-5 text-apn-saffron" />
            </li>
          ))}
        </ul>
      </div>

      {/* Results ticker: dated wins */}
      <div
        className="home-marquee-wrap mt-8 overflow-hidden bg-apn-ink py-4 text-apn-bg sm:mt-10"
        role="region"
        aria-label="Recent client wins"
        tabIndex={0}
      >
        <div className="home-marquee" style={{ '--home-marquee-duration': '45s' }}>
          {[0, 1].map((copy) => (
            <ul key={copy} data-marquee-copy={copy} aria-hidden={copy === 1 || undefined} className="flex shrink-0 items-center">
              {RESULTS_TICKER.map((item) => (
                <li key={`${copy}-${item.client}`} className="flex items-center gap-3 whitespace-nowrap px-5 text-base sm:text-lg">
                  <span className="font-display font-extrabold text-apn-saffron">{item.client}</span>
                  <span className="font-semibold">{item.text}</span>
                  <span className="text-sm opacity-60">{item.date}</span>
                  <Sparkle className="ml-3 h-3.5 w-3.5 text-apn-pink" />
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>

      {/* Client logos */}
      <div className="mx-auto mt-8 max-w-7xl px-4 sm:mt-10 sm:px-6 lg:px-8">
        <p className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.16em] text-apn-muted">
          Brands that trusted us with their name
        </p>
      </div>
      <div className="home-marquee-wrap overflow-hidden" role="region" aria-label="Client logos" tabIndex={0}>
        <div className="home-marquee" style={{ '--home-marquee-duration': '55s' }}>
          {[0, 1].map((copy) => (
            <ul key={copy} data-marquee-copy={copy} aria-hidden={copy === 1 || undefined} className="flex shrink-0 items-center gap-3 pr-3">
              {CLIENT_LOGOS.map((logo) => (
                <li
                  key={`${copy}-${logo.src}`}
                  className="flex h-16 w-36 shrink-0 items-center justify-center rounded-2xl bg-apn-surface px-4 dark:bg-apn-ink sm:h-20 sm:w-44"
                >
                  <img
                    src={logo.src}
                    alt={copy === 1 ? '' : logo.alt}
                    loading="lazy"
                    decoding="async"
                    width="140"
                    height="48"
                    className="h-10 w-full object-contain sm:h-12"
                  />
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </section>
  );
}
